<template>
  <div class="countdown-timer">
    <span v-if="daysLeft > 0">{{ daysLeft }}{{ human ? (daysLeft > 1 ? ' dagen ' : ' dag ') : ':' }}</span><span
      v-if="hoursLeft > 0">{{ paddedHours }}{{ human ? ' uur ' : ':' }}</span><span
      v-if="minutesLeft > 0">{{ paddedMinutes }}{{ human ? (minutesLeft > 1 ? ' minuten ' : ' minuut ') : ':' }}</span>{{
      paddedSeconds
    }}{{ human ? (secondsLeft > 1 ? ' seconden ' : ' seconde ') : ':' }}
  </div>
</template>

<script type="text/javascript">
const moment = require('moment');

export default {
  name: "CountdownTimerComponent",
  props: {
    seconds: {
      type: Number,
      required: true,
    },
    human: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return {
      interval: null,
      daysLeft: 0,
      hoursLeft: 0,
      minutesLeft: 0,
      secondsLeft: 0,
      now: null,
      time: null,
    };
  },
  computed: {
    paddedHours() {
      return this.hoursLeft > 9 ? this.hoursLeft : '0' + this.hoursLeft;
    },
    paddedMinutes() {
      return this.minutesLeft > 9 ? this.minutesLeft : '0' + this.minutesLeft;
    },
    paddedSeconds() {
      return this.secondsLeft > 9 ? this.secondsLeft : '0' + this.secondsLeft;
    },
  },
  mounted() {
    this.time = moment().add(this.seconds, 'seconds');
    this.updateCountdown(moment(), this.time);

    this.interval = setInterval(() => {
      this.updateCountdown(moment(), this.time);
    }, 1000);
  },
  methods: {
    updateCountdown(start, end) {
      this.secondsLeft = end.diff(start, 'seconds') % 60;
      this.minutesLeft = Math.floor((end.diff(start, 'seconds') % (60 * 60)) / 60);
      this.hoursLeft = Math.floor((end.diff(start, 'seconds') % (60 * 60 * 24)) / (60 * 60));
      this.daysLeft = Math.floor(end.diff(start, 'seconds') / (60 * 60 * 24));


      if (end.isBefore(start)) {
        clearInterval(this.interval);
        this.$emit('done');
      }
    }
  }
}
</script>

<style scoped>
.countdown-timer {
  display: inline-block;
}
</style>
